import { render, staticRenderFns } from "./receiving-address-new.vue?vue&type=template&id=cdb3e2c0&scoped=true&"
import script from "./receiving-address-new.vue?vue&type=script&lang=js&"
export * from "./receiving-address-new.vue?vue&type=script&lang=js&"
import style0 from "./receiving-address-new.vue?vue&type=style&index=0&id=cdb3e2c0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb3e2c0",
  null
  
)

export default component.exports